import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ConnectionNode } from 'dashboard/models/platform-node';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint, ApiModel, ApiResponse } from 'lib/interfaces/api';

interface PlatformConnectionsQueryResponseType {
  'root-node': ConnectionNode;
  'inbound-connections': ConnectionNode[];
  'outbound-connections': ConnectionNode[];
}

export const platformNodeApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlatformConnections: builder.query<
      {
        rootNode: ConnectionNode | null;
        inboundConnections: ConnectionNode[];
        outboundConnections: ConnectionNode[];
      },
      string
    >({
      query: (platformNodeId) =>
        SessionClientDashboard.getResourceMeta<PlatformConnectionsQueryResponseType>(
          ApiEndpoint.PlatformNode,
          `${platformNodeId}/connections`,
        ),
      transformResponse: (response: ApiResponse<never, PlatformConnectionsQueryResponseType>) => ({
        inboundConnections: response.meta?.['inbound-connections'] || [],
        outboundConnections: response.meta?.['outbound-connections'] || [],
        rootNode: response.meta?.['root-node'] || null,
      }),
      providesTags: (_result, _error, platformNodeId) => {
        return [{ type: ApiModel.PlatformNode, id: platformNodeId }];
      },
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const { useGetPlatformConnectionsQuery } = platformNodeApi;
